var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.hasChild != null ? 'main' : 'main right-big'},[_c('LeftMenu',{on:{"selectMenu":_vm.selectMenuFunc}}),_vm._v(" "),_c('RightContent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-072bef7a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/main.vue
// module id = null
// module chunks = 